import React from 'react'
import './Loading.css'

export default () => (
  <div className="sk-chasing-dots">
    <div className="sk-child sk-dot1"></div>
    <div className="sk-child sk-dot2"></div>
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Loading.js